// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%278%27 viewBox=%270 0 12 8%27%3E%3Cpath d=%27M1 1l5 5 5-5%27 fill=%27none%27 stroke=%27%2346506b%27 stroke-width=%271.6%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* /oferta: the public page where a receptor quotes from the email link.
   Its own frame: white, navy and a measured gold, with every rule scoped
   under .oferta-page. Light only: the receptor opens it from the email
   without a session, so the app theme does not apply. */

.oferta-page {
  --of-bg: #ffffff;
  --of-bg-2: #f7f8fb;
  --of-ink: #0a1633;
  --of-ink-2: #46506b;
  --of-muted: #646d85;
  --of-line: #e4e7ef;
  --of-line-2: #eef0f5;
  --of-navy: #0a1633;
  --of-navy-2: #16234d;
  --of-gold: #b8891c;
  --of-gold-2: #8f6a12;
  --of-gold-soft: #fbf3dd;
  --of-ok: #157a3c;
  --of-ok-bg: #e6f6ec;
  --of-err: #c0281b;
  --of-err-bg: #fdeceb;
  --of-ring: 0 0 0 3px rgba(10, 22, 51, 0.12);
  /* Keyboard focus on controls without a border of their own: the soft ring
     alone is too faint against white. */
  --of-focus: 2px solid var(--of-navy);
  --of-r: 10px;
  --of-r-sm: 8px;

  color-scheme: light;
  min-height: 100dvh;
  background: var(--of-bg);
  color: var(--of-ink);
  font-family: var(--font-sans);
  font-size: 15px;
  line-height: 1.5;
}

.oferta-page *,
.oferta-page *::before,
.oferta-page *::after {
  box-sizing: border-box;
}

/* :where() keeps the reset at class weight, so a single-class rule below
   (.oferta-lede, .oferta-about) can set its own margin. */
.oferta-page :where(p, h1, h2, h3, dl, dd) {
  margin: 0;
}

.oferta-page svg {
  display: block;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.6;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.oferta:focus {
  outline: none;
}

.oferta-wrap {
  width: 100%;
  max-width: 1120px;
  margin: 0 auto;
  padding-left: 20px;
  padding-right: 20px;
}

/* ── top bar: the brand only, no login link on the public page ── */
.oferta-top {
  border-bottom: 1px solid var(--of-line-2);
}

.oferta-top .oferta-wrap {
  height: 64px;
  display: flex;
  align-items: center;
}

.oferta-brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: var(--of-navy);
}

.oferta-brand__mark {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: var(--of-navy);
  display: grid;
  place-items: center;
}

.oferta-brand__mark img {
  width: 20px;
  height: 20px;
  display: block;
}

.oferta-wm {
  font-family: 'Newsreader', Georgia, serif;
  font-size: 18px;
  letter-spacing: 0.04em;
  line-height: 1;
}

.oferta-wm span {
  font-weight: 300;
}

.oferta-wm b {
  font-weight: 600;
}

/* ── open: head | side (form) | rest. On the phone the form comes right
   after the head; on the desk it is the right column, head and rest the
   left one. ── */
.oferta-body {
  display: grid;
  gap: 32px;
  padding-top: 32px;
  padding-bottom: 96px;
}

.oferta-kicker {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 500;
  color: var(--of-ink-2);
}

.oferta-kicker::before {
  content: '';
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--of-gold);
}

.oferta-title {
  font-size: clamp(30px, 3.6vw, 40px);
  font-weight: 600;
  letter-spacing: -0.025em;
  line-height: 1.08;
  margin-top: 14px;
  text-wrap: balance;
  max-width: 16ch;
  overflow-wrap: anywhere;
}

.oferta-lede {
  margin-top: 16px;
  font-size: 16px;
  line-height: 1.55;
  color: var(--of-ink-2);
  max-width: 52ch;
}

/* key facts: icon rows, flat */
.oferta-facts {
  list-style: none;
  margin: 28px 0 0;
  padding: 0;
  border-top: 1px solid var(--of-line);
  border-bottom: 1px solid var(--of-line);
}

.oferta-facts--rest {
  margin-top: 0;
  border-top: 0;
}

.oferta-fact {
  display: grid;
  grid-template-columns: 36px minmax(0, 1fr);
  column-gap: 14px;
  align-items: start;
  padding: 14px 0;
  border-bottom: 1px solid var(--of-line-2);
}

.oferta-fact:last-child {
  border-bottom: 0;
}

.oferta-fact__icon {
  width: 36px;
  height: 36px;
  border-radius: 9px;
  background: var(--of-bg-2);
  display: grid;
  place-items: center;
  color: var(--of-navy);
}

.oferta-fact__icon svg {
  width: 18px;
  height: 18px;
}

.oferta-fact__k {
  font-size: 13px;
  color: var(--of-muted);
  margin-bottom: 2px;
}

.oferta-fact__v {
  font-size: 15px;
  font-weight: 500;
  overflow-wrap: anywhere;
}

.oferta-fact__v small {
  display: block;
  margin-top: 2px;
  font-size: 14px;
  font-weight: 400;
  color: var(--of-ink-2);
}

.oferta-fact__v ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.oferta-fact__v li {
  font-weight: 400;
}

.oferta-fact__v li + li {
  margin-top: 2px;
}

.oferta-plazo {
  display: flex;
  align-items: baseline;
  gap: 8px;
  flex-wrap: wrap;
}

.oferta-plazo__n {
  font-size: 30px;
  font-weight: 600;
  letter-spacing: -0.03em;
  line-height: 1;
  color: var(--of-gold-2);
  font-variant-numeric: tabular-nums;
}

.oferta-plazo__u {
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0;
  margin-left: 1px;
}

.oferta-plazo__n--text {
  font-size: 22px;
}

.oferta-plazo.is-late .oferta-plazo__n {
  color: var(--of-err);
}

/* the lawyer's note, in a gold tint */
.oferta-note {
  margin-top: 28px;
  border-radius: var(--of-r);
  background: var(--of-gold-soft);
  padding: 16px 18px;
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 12px;
  align-items: start;
}

.oferta-note svg {
  width: 18px;
  height: 18px;
  color: var(--of-gold-2);
  margin-top: 3px;
}

.oferta-note h2 {
  font-size: 13px;
  font-weight: 500;
  color: var(--of-gold-2);
  margin-bottom: 2px;
}

.oferta-note p {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

/* the whole request, folded */
.oferta-detail {
  margin-top: 28px;
  border: 1px solid var(--of-line);
  border-radius: var(--of-r);
}

.oferta-detail summary {
  list-style: none;
  cursor: pointer;
  padding: 14px 18px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-radius: var(--of-r);
}

.oferta-detail summary::-webkit-details-marker {
  display: none;
}

.oferta-detail summary svg {
  width: 16px;
  height: 16px;
  color: var(--of-ink-2);
  stroke-width: 1.8;
  transition: transform 150ms cubic-bezier(0.23, 1, 0.32, 1);
}

.oferta-detail[open] summary svg {
  transform: rotate(180deg);
}

.oferta-detail[open] summary {
  border-bottom: 1px solid var(--of-line-2);
  border-radius: var(--of-r) var(--of-r) 0 0;
}

.oferta-group {
  padding: 12px 18px 6px;
}

.oferta-group + .oferta-group {
  border-top: 1px solid var(--of-line-2);
}

.oferta-group h3 {
  font-size: 13px;
  font-weight: 500;
  color: var(--of-muted);
  margin-bottom: 4px;
}

.oferta-row {
  display: grid;
  grid-template-columns: 150px minmax(0, 1fr);
  column-gap: 16px;
  padding: 7px 0;
  align-items: baseline;
}

.oferta-row dt {
  font-size: 13.5px;
  color: var(--of-ink-2);
}

.oferta-row dd {
  font-size: 14px;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.oferta-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.oferta-list li + li {
  margin-top: 2px;
}

/* what happens next, who Recepthor is */
.oferta-after {
  margin-top: 36px;
}

.oferta-after h2 {
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 12px;
}

.oferta-steps {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 10px;
}

.oferta-steps li {
  display: grid;
  grid-template-columns: 26px 1fr;
  gap: 12px;
  align-items: start;
  font-size: 14px;
  color: var(--of-ink-2);
}

.oferta-steps li b {
  display: block;
  font-weight: 500;
  color: var(--of-ink);
}

.oferta-steps__n {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: 1px solid var(--of-line);
  display: grid;
  place-items: center;
  font-size: 12px;
  font-weight: 600;
  color: var(--of-navy);
}

.oferta-steps li.is-now .oferta-steps__n {
  background: var(--of-navy);
  border-color: var(--of-navy);
  color: #fff;
}

.oferta-about {
  margin-top: 22px;
  font-size: 13.5px;
  color: var(--of-ink-2);
  max-width: 60ch;
}

.oferta-reopen {
  margin-top: 14px;
  font-size: 12.5px;
  color: var(--of-muted);
}

/* ── the offer card ── */
.oferta-card {
  border: 1px solid var(--of-line);
  border-radius: 14px;
  padding: 24px 20px;
  background: var(--of-bg);
}

.oferta-card h2 {
  font-size: 22px;
  font-weight: 600;
  letter-spacing: -0.02em;
}

.oferta-card__sub {
  margin-top: 6px;
  font-size: 14px;
  color: var(--of-ink-2);
}

.oferta-payout {
  margin-top: 16px;
  padding: 12px 14px;
  border-radius: var(--of-r-sm);
  background: var(--of-bg-2);
  font-size: 13.5px;
  color: var(--of-ink-2);
}

.oferta-trust {
  margin-top: 14px;
  padding: 0 4px;
  display: flex;
  gap: 8px;
  align-items: flex-start;
  font-size: 12.5px;
  color: var(--of-muted);
}

.oferta-trust svg {
  width: 14px;
  height: 14px;
  flex: none;
  margin-top: 2px;
  color: var(--of-gold-2);
  stroke-width: 1.8;
}

.oferta-block {
  margin-top: 24px;
}

.oferta-block h2 {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 6px;
}

.oferta-block p {
  font-size: 14px;
  color: var(--of-ink-2);
}

.oferta-block .btn {
  margin-top: 12px;
}

.oferta-alert {
  margin-top: 12px;
  padding: 10px 14px;
  border-radius: var(--of-r-sm);
  font-size: 13.5px;
}

.oferta-alert--ok {
  background: var(--of-ok-bg);
  color: var(--of-ok);
}

.oferta-alert--err {
  background: var(--of-err-bg);
  color: var(--of-err);
}

/* ── form: the shared primitives, restyled inside this page only ── */
.oferta-form {
  display: flex;
  flex-direction: column;
  gap: 22px;
  margin-top: 22px;
}

.oferta-form-grid {
  display: grid;
  gap: 14px;
}

.oferta-form fieldset {
  margin: 0;
  padding: 0;
  border: 0;
  min-width: 0;
}

.oferta-form legend {
  padding: 0;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 10px;
}

.oferta-form fieldset > p {
  font-size: 13px;
  color: var(--of-ink-2);
  margin: -4px 0 12px;
}

.oferta-form .sold-control {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.oferta-form .sold-control label {
  font-size: 13px;
  font-weight: 500;
  color: var(--of-ink-2);
}

.oferta-form .form-input,
.oferta-form select {
  font: inherit;
  font-size: 15px;
  width: 100%;
  height: 46px;
  min-height: 46px;
  padding: 0 14px;
  border: 1px solid var(--of-line);
  border-radius: var(--of-r-sm);
  background: var(--of-bg);
  color: var(--of-ink);
  box-shadow: none;
  transition:
    border-color 120ms ease,
    box-shadow 120ms ease;
}

.oferta-form .form-input.mono {
  font-family: var(--font-sans);
  font-size: 15px;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
}

.oferta-form .form-input::placeholder {
  color: var(--of-muted);
  font-weight: 400;
}

.oferta-form .form-input:hover,
.oferta-form select:hover {
  border-color: #cfd4e0;
}

.oferta-form .form-input:focus-visible,
.oferta-form select:focus-visible {
  outline: none;
  border-color: var(--of-navy);
  box-shadow: var(--of-ring);
}

.oferta-form .form-input[aria-invalid='true'],
.oferta-form select[aria-invalid='true'] {
  border-color: var(--of-err);
  box-shadow: none;
}

.oferta-form .form-input[aria-invalid='true']:focus-visible,
.oferta-form select[aria-invalid='true']:focus-visible {
  box-shadow: 0 0 0 3px var(--of-err-bg);
}

.oferta-form select {
  appearance: none;
  -webkit-appearance: none;
  padding-right: 36px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 14px center;
}

.oferta-form .form-input:disabled,
.oferta-form select:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.oferta-form .oferta-reopen {
  margin-top: 0;
  color: var(--of-muted);
}

.oferta .sold-form-error {
  margin: 0;
  font-size: 13px;
  color: var(--of-err);
}

.oferta .sold-form-error a {
  color: inherit;
  font-weight: 600;
}

.oferta-terms {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  margin-top: 12px;
  font-size: 14px;
  line-height: 1.4;
  color: var(--of-ink-2);
}

.oferta-terms input {
  width: 18px;
  height: 18px;
  margin: 2px 0 0;
  flex: none;
  accent-color: var(--of-navy);
}

.oferta-form a {
  color: var(--of-navy);
  text-decoration: underline;
  text-underline-offset: 3px;
}

.oferta-form a:focus-visible,
.oferta-form input[type='checkbox']:focus-visible {
  outline: var(--of-focus);
  outline-offset: 2px;
  border-radius: 3px;
}

/* price per recipient (PriceBreakdownFields, shared with the detail) */
.oferta-form .sold-breakdown {
  display: grid;
  gap: 10px;
}

.oferta-form .sold-breakdown > legend {
  font-size: 14px;
  font-weight: 600;
  color: var(--of-ink);
  margin-bottom: 10px;
}

.oferta-form .sold-breakdown__row {
  display: grid;
  gap: 10px;
  padding: 14px 16px;
  border: 1px solid var(--of-line);
  border-radius: var(--of-r);
}

.oferta-form .sold-breakdown__who {
  font-size: 14px;
  color: var(--of-ink-2);
}

.oferta-form .sold-breakdown__who b {
  font-weight: 600;
  color: var(--of-ink);
}

.oferta-form .sold-breakdown__fields {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  align-items: start;
  gap: 12px;
}

.oferta-form .sold-breakdown__sub {
  font-size: 13px;
  color: var(--of-ink-2);
  font-variant-numeric: tabular-nums;
}

.oferta-form .sold-breakdown__total {
  margin-top: 4px;
  padding-top: 14px;
  border-top: 1px solid var(--of-line);
  font-family: var(--font-sans);
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.01em;
  font-variant-numeric: tabular-nums;
  color: var(--of-ink);
}

/* the one advancing action: navy, full width */
.oferta-page .btn {
  border-radius: var(--of-r-sm);
  transition:
    background 120ms ease,
    border-color 120ms ease,
    transform 160ms cubic-bezier(0.23, 1, 0.32, 1);
}

.oferta-page .btn:active {
  transform: scale(0.98);
}

.oferta-page .btn:focus-visible {
  outline: var(--of-focus);
  outline-offset: 2px;
  box-shadow: var(--of-ring);
}

.oferta-page .btn-seal {
  background: var(--of-navy);
  border-color: var(--of-navy);
  color: #fff;
  box-shadow: none;
}

.oferta-page .btn-seal:hover {
  background: var(--of-navy-2);
  border-color: var(--of-navy-2);
}

.oferta-page .btn-secondary {
  background: var(--of-bg);
  color: var(--of-navy);
  border-color: var(--of-line);
}

.oferta-page .btn-secondary:hover {
  background: var(--of-bg);
  border-color: var(--of-navy);
}

.oferta-submit {
  width: 100%;
  font-size: 15px;
}

/* ── the other states: one column ── */
.oferta-result {
  max-width: 640px;
  margin: 0 auto;
  padding-top: 48px;
  padding-bottom: 96px;
}

.oferta-result .oferta-title {
  max-width: 18ch;
}

.oferta-check {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--of-ok-bg);
  color: var(--of-ok);
  display: grid;
  place-items: center;
  margin-bottom: 20px;
}

.oferta-check svg {
  width: 22px;
  height: 22px;
  stroke-width: 2.2;
}

.oferta-status {
  margin-top: 14px;
  font-size: 16px;
  color: var(--of-ink-2);
}

.oferta-result .btn {
  margin-top: 16px;
}

.oferta-summary {
  margin-top: 24px;
  border: 1px solid var(--of-line);
  border-radius: var(--of-r);
  padding: 16px 18px;
  display: grid;
  gap: 8px;
  font-size: 14px;
  color: var(--of-ink-2);
}

.oferta-summary__price {
  font-size: 22px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: var(--of-ink);
  font-variant-numeric: tabular-nums;
}

.oferta-result .oferta-payout {
  margin-top: 16px;
}

@media (min-width: 768px) {
  .oferta-wrap {
    padding-left: 40px;
    padding-right: 40px;
  }

  .oferta-form-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .oferta-card {
    padding: 28px;
  }
}

@media (min-width: 1024px) {
  .oferta-body {
    grid-template-columns: minmax(0, 1fr) 460px;
    grid-template-rows: auto 1fr;
    column-gap: 72px;
    row-gap: 0;
    padding-top: 56px;
  }

  .oferta-head {
    grid-column: 1;
    grid-row: 1;
  }

  .oferta-rest {
    grid-column: 1;
    grid-row: 2;
  }

  .oferta-side {
    grid-column: 2;
    grid-row: 1 / 3;
  }
}

@media (max-width: 480px) {
  .oferta-row {
    grid-template-columns: 1fr;
    row-gap: 1px;
    padding: 8px 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .oferta-page .btn,
  .oferta-form .form-input,
  .oferta-detail summary svg {
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/oferta/Oferta.css"],"names":[],"mappings":"AAAA;;;wDAGwD;;AAExD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,2CAA2C;EAC3C;wCACsC;EACtC,oCAAoC;EACpC,YAAY;EACZ,cAAc;;EAEd,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;0DAC0D;AAC1D;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,oEAAoE;AACpE;EACE,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;iBAEiB;AACjB;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,sCAAsC;AACtC;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,0DAA0D;AAC5D;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA,wCAAwC;AACxC;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA,sEAAsE;AACtE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAS;EACT,UAAU;EACV,SAAS;EACT,YAAY;AACd;;AAEA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,6BAA6B;EAC7B,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB;;yBAEuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;EACb,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;;EAEE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;;EAEE,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,yDAAyN;EACzN,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;;EAEE,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,oCAAoC;EACpC,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA,+CAA+C;AAC/C;EACE,6BAA6B;EAC7B;;;kDAGgD;AAClD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,uCAAuC;AACvC;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,2CAA2C;IAC3C,4BAA4B;IAC5B,gBAAgB;IAChB,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,YAAY;IACZ,cAAc;EAChB;AACF;;AAEA;EACE;;;IAGE,gBAAgB;EAClB;AACF","sourcesContent":["/* /oferta: the public page where a receptor quotes from the email link.\n   Its own frame: white, navy and a measured gold, with every rule scoped\n   under .oferta-page. Light only: the receptor opens it from the email\n   without a session, so the app theme does not apply. */\n\n.oferta-page {\n  --of-bg: #ffffff;\n  --of-bg-2: #f7f8fb;\n  --of-ink: #0a1633;\n  --of-ink-2: #46506b;\n  --of-muted: #646d85;\n  --of-line: #e4e7ef;\n  --of-line-2: #eef0f5;\n  --of-navy: #0a1633;\n  --of-navy-2: #16234d;\n  --of-gold: #b8891c;\n  --of-gold-2: #8f6a12;\n  --of-gold-soft: #fbf3dd;\n  --of-ok: #157a3c;\n  --of-ok-bg: #e6f6ec;\n  --of-err: #c0281b;\n  --of-err-bg: #fdeceb;\n  --of-ring: 0 0 0 3px rgba(10, 22, 51, 0.12);\n  /* Keyboard focus on controls without a border of their own: the soft ring\n     alone is too faint against white. */\n  --of-focus: 2px solid var(--of-navy);\n  --of-r: 10px;\n  --of-r-sm: 8px;\n\n  color-scheme: light;\n  min-height: 100dvh;\n  background: var(--of-bg);\n  color: var(--of-ink);\n  font-family: var(--font-sans);\n  font-size: 15px;\n  line-height: 1.5;\n}\n\n.oferta-page *,\n.oferta-page *::before,\n.oferta-page *::after {\n  box-sizing: border-box;\n}\n\n/* :where() keeps the reset at class weight, so a single-class rule below\n   (.oferta-lede, .oferta-about) can set its own margin. */\n.oferta-page :where(p, h1, h2, h3, dl, dd) {\n  margin: 0;\n}\n\n.oferta-page svg {\n  display: block;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 1.6;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.oferta:focus {\n  outline: none;\n}\n\n.oferta-wrap {\n  width: 100%;\n  max-width: 1120px;\n  margin: 0 auto;\n  padding-left: 20px;\n  padding-right: 20px;\n}\n\n/* ── top bar: the brand only, no login link on the public page ── */\n.oferta-top {\n  border-bottom: 1px solid var(--of-line-2);\n}\n\n.oferta-top .oferta-wrap {\n  height: 64px;\n  display: flex;\n  align-items: center;\n}\n\n.oferta-brand {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  color: var(--of-navy);\n}\n\n.oferta-brand__mark {\n  width: 30px;\n  height: 30px;\n  border-radius: 8px;\n  background: var(--of-navy);\n  display: grid;\n  place-items: center;\n}\n\n.oferta-brand__mark img {\n  width: 20px;\n  height: 20px;\n  display: block;\n}\n\n.oferta-wm {\n  font-family: 'Newsreader', Georgia, serif;\n  font-size: 18px;\n  letter-spacing: 0.04em;\n  line-height: 1;\n}\n\n.oferta-wm span {\n  font-weight: 300;\n}\n\n.oferta-wm b {\n  font-weight: 600;\n}\n\n/* ── open: head | side (form) | rest. On the phone the form comes right\n   after the head; on the desk it is the right column, head and rest the\n   left one. ── */\n.oferta-body {\n  display: grid;\n  gap: 32px;\n  padding-top: 32px;\n  padding-bottom: 96px;\n}\n\n.oferta-kicker {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--of-ink-2);\n}\n\n.oferta-kicker::before {\n  content: '';\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--of-gold);\n}\n\n.oferta-title {\n  font-size: clamp(30px, 3.6vw, 40px);\n  font-weight: 600;\n  letter-spacing: -0.025em;\n  line-height: 1.08;\n  margin-top: 14px;\n  text-wrap: balance;\n  max-width: 16ch;\n  overflow-wrap: anywhere;\n}\n\n.oferta-lede {\n  margin-top: 16px;\n  font-size: 16px;\n  line-height: 1.55;\n  color: var(--of-ink-2);\n  max-width: 52ch;\n}\n\n/* key facts: icon rows, flat */\n.oferta-facts {\n  list-style: none;\n  margin: 28px 0 0;\n  padding: 0;\n  border-top: 1px solid var(--of-line);\n  border-bottom: 1px solid var(--of-line);\n}\n\n.oferta-facts--rest {\n  margin-top: 0;\n  border-top: 0;\n}\n\n.oferta-fact {\n  display: grid;\n  grid-template-columns: 36px minmax(0, 1fr);\n  column-gap: 14px;\n  align-items: start;\n  padding: 14px 0;\n  border-bottom: 1px solid var(--of-line-2);\n}\n\n.oferta-fact:last-child {\n  border-bottom: 0;\n}\n\n.oferta-fact__icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 9px;\n  background: var(--of-bg-2);\n  display: grid;\n  place-items: center;\n  color: var(--of-navy);\n}\n\n.oferta-fact__icon svg {\n  width: 18px;\n  height: 18px;\n}\n\n.oferta-fact__k {\n  font-size: 13px;\n  color: var(--of-muted);\n  margin-bottom: 2px;\n}\n\n.oferta-fact__v {\n  font-size: 15px;\n  font-weight: 500;\n  overflow-wrap: anywhere;\n}\n\n.oferta-fact__v small {\n  display: block;\n  margin-top: 2px;\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--of-ink-2);\n}\n\n.oferta-fact__v ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.oferta-fact__v li {\n  font-weight: 400;\n}\n\n.oferta-fact__v li + li {\n  margin-top: 2px;\n}\n\n.oferta-plazo {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.oferta-plazo__n {\n  font-size: 30px;\n  font-weight: 600;\n  letter-spacing: -0.03em;\n  line-height: 1;\n  color: var(--of-gold-2);\n  font-variant-numeric: tabular-nums;\n}\n\n.oferta-plazo__u {\n  font-size: 18px;\n  font-weight: 500;\n  letter-spacing: 0;\n  margin-left: 1px;\n}\n\n.oferta-plazo__n--text {\n  font-size: 22px;\n}\n\n.oferta-plazo.is-late .oferta-plazo__n {\n  color: var(--of-err);\n}\n\n/* the lawyer's note, in a gold tint */\n.oferta-note {\n  margin-top: 28px;\n  border-radius: var(--of-r);\n  background: var(--of-gold-soft);\n  padding: 16px 18px;\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: 12px;\n  align-items: start;\n}\n\n.oferta-note svg {\n  width: 18px;\n  height: 18px;\n  color: var(--of-gold-2);\n  margin-top: 3px;\n}\n\n.oferta-note h2 {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--of-gold-2);\n  margin-bottom: 2px;\n}\n\n.oferta-note p {\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n\n/* the whole request, folded */\n.oferta-detail {\n  margin-top: 28px;\n  border: 1px solid var(--of-line);\n  border-radius: var(--of-r);\n}\n\n.oferta-detail summary {\n  list-style: none;\n  cursor: pointer;\n  padding: 14px 18px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  border-radius: var(--of-r);\n}\n\n.oferta-detail summary::-webkit-details-marker {\n  display: none;\n}\n\n.oferta-detail summary svg {\n  width: 16px;\n  height: 16px;\n  color: var(--of-ink-2);\n  stroke-width: 1.8;\n  transition: transform 150ms cubic-bezier(0.23, 1, 0.32, 1);\n}\n\n.oferta-detail[open] summary svg {\n  transform: rotate(180deg);\n}\n\n.oferta-detail[open] summary {\n  border-bottom: 1px solid var(--of-line-2);\n  border-radius: var(--of-r) var(--of-r) 0 0;\n}\n\n.oferta-group {\n  padding: 12px 18px 6px;\n}\n\n.oferta-group + .oferta-group {\n  border-top: 1px solid var(--of-line-2);\n}\n\n.oferta-group h3 {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--of-muted);\n  margin-bottom: 4px;\n}\n\n.oferta-row {\n  display: grid;\n  grid-template-columns: 150px minmax(0, 1fr);\n  column-gap: 16px;\n  padding: 7px 0;\n  align-items: baseline;\n}\n\n.oferta-row dt {\n  font-size: 13.5px;\n  color: var(--of-ink-2);\n}\n\n.oferta-row dd {\n  font-size: 14px;\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n\n.oferta-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.oferta-list li + li {\n  margin-top: 2px;\n}\n\n/* what happens next, who Recepthor is */\n.oferta-after {\n  margin-top: 36px;\n}\n\n.oferta-after h2 {\n  font-size: 15px;\n  font-weight: 500;\n  margin-bottom: 12px;\n}\n\n.oferta-steps {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  gap: 10px;\n}\n\n.oferta-steps li {\n  display: grid;\n  grid-template-columns: 26px 1fr;\n  gap: 12px;\n  align-items: start;\n  font-size: 14px;\n  color: var(--of-ink-2);\n}\n\n.oferta-steps li b {\n  display: block;\n  font-weight: 500;\n  color: var(--of-ink);\n}\n\n.oferta-steps__n {\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  border: 1px solid var(--of-line);\n  display: grid;\n  place-items: center;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--of-navy);\n}\n\n.oferta-steps li.is-now .oferta-steps__n {\n  background: var(--of-navy);\n  border-color: var(--of-navy);\n  color: #fff;\n}\n\n.oferta-about {\n  margin-top: 22px;\n  font-size: 13.5px;\n  color: var(--of-ink-2);\n  max-width: 60ch;\n}\n\n.oferta-reopen {\n  margin-top: 14px;\n  font-size: 12.5px;\n  color: var(--of-muted);\n}\n\n/* ── the offer card ── */\n.oferta-card {\n  border: 1px solid var(--of-line);\n  border-radius: 14px;\n  padding: 24px 20px;\n  background: var(--of-bg);\n}\n\n.oferta-card h2 {\n  font-size: 22px;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n}\n\n.oferta-card__sub {\n  margin-top: 6px;\n  font-size: 14px;\n  color: var(--of-ink-2);\n}\n\n.oferta-payout {\n  margin-top: 16px;\n  padding: 12px 14px;\n  border-radius: var(--of-r-sm);\n  background: var(--of-bg-2);\n  font-size: 13.5px;\n  color: var(--of-ink-2);\n}\n\n.oferta-trust {\n  margin-top: 14px;\n  padding: 0 4px;\n  display: flex;\n  gap: 8px;\n  align-items: flex-start;\n  font-size: 12.5px;\n  color: var(--of-muted);\n}\n\n.oferta-trust svg {\n  width: 14px;\n  height: 14px;\n  flex: none;\n  margin-top: 2px;\n  color: var(--of-gold-2);\n  stroke-width: 1.8;\n}\n\n.oferta-block {\n  margin-top: 24px;\n}\n\n.oferta-block h2 {\n  font-size: 16px;\n  font-weight: 500;\n  margin-bottom: 6px;\n}\n\n.oferta-block p {\n  font-size: 14px;\n  color: var(--of-ink-2);\n}\n\n.oferta-block .btn {\n  margin-top: 12px;\n}\n\n.oferta-alert {\n  margin-top: 12px;\n  padding: 10px 14px;\n  border-radius: var(--of-r-sm);\n  font-size: 13.5px;\n}\n\n.oferta-alert--ok {\n  background: var(--of-ok-bg);\n  color: var(--of-ok);\n}\n\n.oferta-alert--err {\n  background: var(--of-err-bg);\n  color: var(--of-err);\n}\n\n/* ── form: the shared primitives, restyled inside this page only ── */\n.oferta-form {\n  display: flex;\n  flex-direction: column;\n  gap: 22px;\n  margin-top: 22px;\n}\n\n.oferta-form-grid {\n  display: grid;\n  gap: 14px;\n}\n\n.oferta-form fieldset {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  min-width: 0;\n}\n\n.oferta-form legend {\n  padding: 0;\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n\n.oferta-form fieldset > p {\n  font-size: 13px;\n  color: var(--of-ink-2);\n  margin: -4px 0 12px;\n}\n\n.oferta-form .sold-control {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n}\n\n.oferta-form .sold-control label {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--of-ink-2);\n}\n\n.oferta-form .form-input,\n.oferta-form select {\n  font: inherit;\n  font-size: 15px;\n  width: 100%;\n  height: 46px;\n  min-height: 46px;\n  padding: 0 14px;\n  border: 1px solid var(--of-line);\n  border-radius: var(--of-r-sm);\n  background: var(--of-bg);\n  color: var(--of-ink);\n  box-shadow: none;\n  transition:\n    border-color 120ms ease,\n    box-shadow 120ms ease;\n}\n\n.oferta-form .form-input.mono {\n  font-family: var(--font-sans);\n  font-size: 15px;\n  font-weight: 500;\n  font-variant-numeric: tabular-nums;\n}\n\n.oferta-form .form-input::placeholder {\n  color: var(--of-muted);\n  font-weight: 400;\n}\n\n.oferta-form .form-input:hover,\n.oferta-form select:hover {\n  border-color: #cfd4e0;\n}\n\n.oferta-form .form-input:focus-visible,\n.oferta-form select:focus-visible {\n  outline: none;\n  border-color: var(--of-navy);\n  box-shadow: var(--of-ring);\n}\n\n.oferta-form .form-input[aria-invalid='true'],\n.oferta-form select[aria-invalid='true'] {\n  border-color: var(--of-err);\n  box-shadow: none;\n}\n\n.oferta-form .form-input[aria-invalid='true']:focus-visible,\n.oferta-form select[aria-invalid='true']:focus-visible {\n  box-shadow: 0 0 0 3px var(--of-err-bg);\n}\n\n.oferta-form select {\n  appearance: none;\n  -webkit-appearance: none;\n  padding-right: 36px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' fill='none' stroke='%2346506b' stroke-width='1.6'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 14px center;\n}\n\n.oferta-form .form-input:disabled,\n.oferta-form select:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.oferta-form .oferta-reopen {\n  margin-top: 0;\n  color: var(--of-muted);\n}\n\n.oferta .sold-form-error {\n  margin: 0;\n  font-size: 13px;\n  color: var(--of-err);\n}\n\n.oferta .sold-form-error a {\n  color: inherit;\n  font-weight: 600;\n}\n\n.oferta-terms {\n  display: flex;\n  gap: 10px;\n  align-items: flex-start;\n  margin-top: 12px;\n  font-size: 14px;\n  line-height: 1.4;\n  color: var(--of-ink-2);\n}\n\n.oferta-terms input {\n  width: 18px;\n  height: 18px;\n  margin: 2px 0 0;\n  flex: none;\n  accent-color: var(--of-navy);\n}\n\n.oferta-form a {\n  color: var(--of-navy);\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n\n.oferta-form a:focus-visible,\n.oferta-form input[type='checkbox']:focus-visible {\n  outline: var(--of-focus);\n  outline-offset: 2px;\n  border-radius: 3px;\n}\n\n/* price per recipient (PriceBreakdownFields, shared with the detail) */\n.oferta-form .sold-breakdown {\n  display: grid;\n  gap: 10px;\n}\n\n.oferta-form .sold-breakdown > legend {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--of-ink);\n  margin-bottom: 10px;\n}\n\n.oferta-form .sold-breakdown__row {\n  display: grid;\n  gap: 10px;\n  padding: 14px 16px;\n  border: 1px solid var(--of-line);\n  border-radius: var(--of-r);\n}\n\n.oferta-form .sold-breakdown__who {\n  font-size: 14px;\n  color: var(--of-ink-2);\n}\n\n.oferta-form .sold-breakdown__who b {\n  font-weight: 600;\n  color: var(--of-ink);\n}\n\n.oferta-form .sold-breakdown__fields {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n  align-items: start;\n  gap: 12px;\n}\n\n.oferta-form .sold-breakdown__sub {\n  font-size: 13px;\n  color: var(--of-ink-2);\n  font-variant-numeric: tabular-nums;\n}\n\n.oferta-form .sold-breakdown__total {\n  margin-top: 4px;\n  padding-top: 14px;\n  border-top: 1px solid var(--of-line);\n  font-family: var(--font-sans);\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  font-variant-numeric: tabular-nums;\n  color: var(--of-ink);\n}\n\n/* the one advancing action: navy, full width */\n.oferta-page .btn {\n  border-radius: var(--of-r-sm);\n  transition:\n    background 120ms ease,\n    border-color 120ms ease,\n    transform 160ms cubic-bezier(0.23, 1, 0.32, 1);\n}\n\n.oferta-page .btn:active {\n  transform: scale(0.98);\n}\n\n.oferta-page .btn:focus-visible {\n  outline: var(--of-focus);\n  outline-offset: 2px;\n  box-shadow: var(--of-ring);\n}\n\n.oferta-page .btn-seal {\n  background: var(--of-navy);\n  border-color: var(--of-navy);\n  color: #fff;\n  box-shadow: none;\n}\n\n.oferta-page .btn-seal:hover {\n  background: var(--of-navy-2);\n  border-color: var(--of-navy-2);\n}\n\n.oferta-page .btn-secondary {\n  background: var(--of-bg);\n  color: var(--of-navy);\n  border-color: var(--of-line);\n}\n\n.oferta-page .btn-secondary:hover {\n  background: var(--of-bg);\n  border-color: var(--of-navy);\n}\n\n.oferta-submit {\n  width: 100%;\n  font-size: 15px;\n}\n\n/* ── the other states: one column ── */\n.oferta-result {\n  max-width: 640px;\n  margin: 0 auto;\n  padding-top: 48px;\n  padding-bottom: 96px;\n}\n\n.oferta-result .oferta-title {\n  max-width: 18ch;\n}\n\n.oferta-check {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: var(--of-ok-bg);\n  color: var(--of-ok);\n  display: grid;\n  place-items: center;\n  margin-bottom: 20px;\n}\n\n.oferta-check svg {\n  width: 22px;\n  height: 22px;\n  stroke-width: 2.2;\n}\n\n.oferta-status {\n  margin-top: 14px;\n  font-size: 16px;\n  color: var(--of-ink-2);\n}\n\n.oferta-result .btn {\n  margin-top: 16px;\n}\n\n.oferta-summary {\n  margin-top: 24px;\n  border: 1px solid var(--of-line);\n  border-radius: var(--of-r);\n  padding: 16px 18px;\n  display: grid;\n  gap: 8px;\n  font-size: 14px;\n  color: var(--of-ink-2);\n}\n\n.oferta-summary__price {\n  font-size: 22px;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  color: var(--of-ink);\n  font-variant-numeric: tabular-nums;\n}\n\n.oferta-result .oferta-payout {\n  margin-top: 16px;\n}\n\n@media (min-width: 768px) {\n  .oferta-wrap {\n    padding-left: 40px;\n    padding-right: 40px;\n  }\n\n  .oferta-form-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .oferta-card {\n    padding: 28px;\n  }\n}\n\n@media (min-width: 1024px) {\n  .oferta-body {\n    grid-template-columns: minmax(0, 1fr) 460px;\n    grid-template-rows: auto 1fr;\n    column-gap: 72px;\n    row-gap: 0;\n    padding-top: 56px;\n  }\n\n  .oferta-head {\n    grid-column: 1;\n    grid-row: 1;\n  }\n\n  .oferta-rest {\n    grid-column: 1;\n    grid-row: 2;\n  }\n\n  .oferta-side {\n    grid-column: 2;\n    grid-row: 1 / 3;\n  }\n}\n\n@media (max-width: 480px) {\n  .oferta-row {\n    grid-template-columns: 1fr;\n    row-gap: 1px;\n    padding: 8px 0;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .oferta-page .btn,\n  .oferta-form .form-input,\n  .oferta-detail summary svg {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
